import type {
  ItemType,
  MenuItemType,
  SubMenuType
} from "antd/es/menu/interface"
import React from "react"

import Icon from "../../Icon"
import { type PermissionPages } from "../SettingsPermissions/types/permissions.types.ts"

interface SubMenu extends Omit<SubMenuType, "children"> {
  children: Array<ItemType>
}

export type SidebarItem = (MenuItemType | SubMenu) & {
  key: PermissionPages | string
}

interface SidebarConfig {
  main: SidebarItem[]
  bottom: SidebarItem[]
}

export const REPORTS_NAV_KEY = "reports"
export const INVOICES_NAV_KEY = "invoices"
export const ARCHIVE_NAV_KEY = "archive"

export const sidebarConfig: SidebarConfig = {
  main: [
    {
      key: "home",
      icon: <Icon type={"Home"} />,
      label: "Home"
    },
    {
      key: REPORTS_NAV_KEY,
      icon: <Icon type={"Report"} />,
      label: "Reports"
    },
    {
      key: "leads",
      icon: <Icon type={"Leads"} />,
      label: "Leads"
    },
    {
      key: "projects",
      icon: <Icon type={"Projects"} />,
      label: "Projects"
    },
    {
      key: ARCHIVE_NAV_KEY,
      icon: <Icon type={"Archive"} />,
      label: "Archive"
    },
    {
      key: "approval",
      icon: <Icon type={"Check"} />,
      label: "Approval",
      children: [
        {
          key: "proposals",
          label: "Proposal Review"
        },
        {
          key: "contracts",
          label: "Contract Review"
        }
      ]
    },
    {
      key: INVOICES_NAV_KEY,
      icon: <Icon type={"Dollar"} />,
      label: "Invoices"
    },
    {
      key: "calendar",
      icon: <Icon type={"Calendar"} />,
      label: "Calendar"
    },
    {
      key: "customers",
      icon: <Icon type={"Customers"} />,
      label: "Customers"
    },
    {
      key: "subcontractors",
      icon: <Icon type={"Subcontractors"} />,
      label: "Subcontractors"
    },
    {
      key: "suppliers",
      icon: <Icon type={"Subcontractors"} />,
      label: "Suppliers"
    },
    {
      key: "team_management",
      icon: <Icon type={"Users"} />,
      label: "Team Management"
    }
  ],
  bottom: [
    {
      key: "settings",
      icon: <Icon type={"Settings"} />,
      label: "Settings"
    }
  ]
}
